module.exports = __webpack_public_path__ + "img/bootstrap-stencil.af581738.svg";